import { createCartConverter } from "@t3/shared";
import {
  DocumentData,
  QueryDocumentSnapshot,
  serverTimestamp,
} from "firebase/firestore";

export const cartConverter = createCartConverter<
  DocumentData,
  QueryDocumentSnapshot
>(serverTimestamp);
